import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useParams } from 'react-router-dom';

import styles from './ArrivalInformation.module.scss';
import { ArrivalInformationResponse, InvoiceMasterResponse } from '../../../apis/models/ArrivalInformationResponse';
import { dateToString } from "../../../libs/helpers"
import { getArrivalInformation } from '../../../apis/invoice-api';


const ArrivalInformation = () => {
    const params = useParams();
    const [informationData, setInformationData] = React.useState<ArrivalInformationResponse>();
    const [invoiceData, setInvoiceData] = React.useState<InvoiceMasterResponse>() 
    const [nComponents, setNComponents] = React.useState<number>(0);

    React.useEffect(() => {
      getArrivalInformation(params.id)
      .then(function (response) {
        const res = response.data.data as InvoiceMasterResponse
        setInvoiceData(res);
        setInformationData(res.arrivalDatas);
      })
      .catch(function (error) {
        console.log(error);
      })
  }, [params.id])

    React.useEffect(() => {
        if(informationData !== undefined) {
          setNComponents(informationData.length);
        }
    },[informationData])

    //csv
    const downloadCsv = async (i: number) => {
        if ( informationData !== undefined ) {
            if( informationData[i] !== undefined ) {
            const ExcelJS = require('exceljs');
            const wb = new ExcelJS.Workbook();
            const date = dateToString(informationData[i]!.arrivalDate).replaceAll('/', '')
            wb.addWorksheet(date);
            const ws = wb.getWorksheet(date);
            const companyName = invoiceData?.companyName;
            ws.getCell('A1').value = `${companyName}御中`;
            ws.getCell('A1').font = { bold: true, size: 14 };
            ws.mergeCells('H1:I1');
            ws.getCell('H1').value = dateToString(informationData[i].arrivalDate);
            ws.getCell('H1').alignment = { horizontal: 'center' };
            ws.getCell('H1').font = { bold: true, size: 11 };
            ws.getCell('H1').border = { bottom: {style:'thin'} };
            ws.mergeCells('D2:F2');
            ws.getCell('D2').value = "商品入荷報告書";
            ws.getCell('D2').alignment = { horizontal: 'center' };
            ws.getCell('D2').font = { bold: true, size: 16 };
            ws.mergeCells('A3:I3');
            ws.getCell('A3').value = `伝票No：${informationData[i].slipNo}`;
            ws.getCell('A3').alignment = { horizontal: 'right' };
            ws.getCell('A3').font = { bold: true, size: 11 };
            ws.getCell('A4').value = "品番";
            ws.getCell('A4').alignment = { horizontal: 'center' };
            ws.getCell('A4').font = { bold: true, size: 14 };
            ws.getCell('A4').border = { top: {style:'thick'}, left: {style:'thick'}, bottom: {style:'thick'}, right: {style:'thick'} };
            ws.mergeCells('B4:D4');
            ws.getCell('B4').value = `${informationData[i].productNumber}`;
            ws.getCell('B4').alignment = { horizontal: 'center' };
            ws.getCell('B4').font = { bold: true, size: 14 };
            ws.getCell('B4').border = { top: {style:'thick'}, left: {style:'thick'}, bottom: {style:'thick'}, right: {style:'thick'} };
            ws.getCell('F4').value = "品名";
            ws.getCell('F4').alignment = { horizontal: 'center' };
            ws.getCell('F4').font = { bold: true, size: 14 };
            ws.getCell('F4').border = { top: {style:'thick'}, left: {style:'thick'}, bottom: {style:'thick'}, right: {style:'thick'} };
            ws.mergeCells('G4:I4');
            ws.getCell('G4').value = `${informationData[i].productName}`;
            ws.getCell('G4').alignment = { horizontal: 'center' };
            ws.getCell('G4').font = { bold: true, size: 14 };
            ws.getCell('G4').border = { top: {style:'thick'}, left: {style:'thick'}, bottom: {style:'thick'}, right: {style:'thick'} };
            ws.mergeCells('A6:C6');
            ws.getCell('A6').value = "COL";
            ws.getCell('A6').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('A6').font = { bold: true, size: 11 };
            ws.getCell('A6').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'double'}, right: {style:'thin'} };
            ws.getCell('A6').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FFFFCC'},
            };
            ws.mergeCells('D6:F6');
            ws.getCell('D6').value = "SIZE";
            ws.getCell('D6').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('D6').font = { bold: true, size: 11 };
            ws.getCell('D6').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'double'}, right: {style:'thin'} };
            ws.getCell('D6').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FFFFCC'},
            };
            ws.mergeCells('G6:I6');
            ws.getCell('G6').value = "数量";
            ws.getCell('G6').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('G6').font = { bold: true, size: 11 };
            ws.getCell('G6').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'double'}, right: {style:'thin'} };
            ws.getCell('G6').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FFFFCC'},
            };
            ws.mergeCells('A7:C7');
            ws.getCell('A7').value = `${informationData[i].color}`;
            ws.getCell('A7').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('A7').font = { bold: true, size: 11 };
            ws.getCell('A7').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('D7:F7');
            ws.getCell('D7').value = `${informationData[i].size}`;
            ws.getCell('D7').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('D7').font = { bold: true, size: 11 };
            ws.getCell('D7').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('G7:I7');
            ws.getCell('G7').value = `${informationData[i].quantity}`;
            ws.getCell('G7').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('G7').font = { bold: true, size: 11 };
            ws.getCell('G7').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('A8:F8');
            ws.getCell('A8').value = "合計";
            ws.getCell('A8').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('A8').font = { bold: true, size: 11 };
            ws.getCell('A8').border = { top: {style:'double'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.getCell('A8').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'99FF99'},
            };
            ws.mergeCells('G8:I8');
            ws.getCell('G8').value = 1;
            ws.getCell('G8').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('G8').font = { bold: true, size: 11 };
            ws.getCell('G8').border = { top: {style:'double'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.getCell('G8').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'99FF99'},
            };
            ws.mergeCells('A11:I11');
            ws.getCell('A11').value = "備考";
            ws.getCell('A11').alignment = { vertical: 'center', horizontal: 'left' };
            ws.getCell('A11').font = { bold: true, size: 11 };
            ws.getCell('A11').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('A12:I13');
            ws.getCell('A12').value = informationData[i].memo ? informationData[i].memo : "";
            ws.getCell('A12').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.getCell('B16').value = "入庫者";
            ws.getCell('B16').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('B16').font = { bold: true, size: 11 };
            ws.getCell('B16').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('B17:B18');
            ws.getCell('B17').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('C16:D16');
            ws.getCell('C16').value = "検数者";
            ws.getCell('C16').alignment = { vertical: 'center', horizontal: 'center' };
            ws.getCell('C16').font = { bold: true, size: 11 };
            ws.getCell('C16').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('C17:D18');
            ws.getCell('C17').border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            ws.mergeCells('F15:I15');
            ws.getCell('F15').value = "（有）VISION LOGISTICS";
            ws.getCell('F15').alignment = { vertical: 'center', horizontal: 'left' };
            ws.getCell('F15').font = { bold: true, size: 11 };
            ws.mergeCells('F16:H16');
            ws.getCell('F16').value = "埼玉県三郷市彦川戸1-330-1";
            ws.getCell('F16').alignment = { vertical: 'center', horizontal: 'left' };
            ws.getCell('F16').font = { bold: true, size: 11 };
            ws.mergeCells('F17:H17');
            ws.getCell('F17').value = "ＴＥＬ　　048-949-1671";
            ws.getCell('F17').alignment = { vertical: 'center', horizontal: 'left' };
            ws.getCell('F17').font = { bold: true, size: 11 };
            ws.mergeCells('F18:H18');
            ws.getCell('F18').value = "ＦＡＸ　　048-949-1672";
            ws.getCell('F18').alignment = { vertical: 'center', horizontal: 'left' };
            ws.getCell('F18').font = { bold: true, size: 11 };


            const uint8Array = await wb.xlsx.writeBuffer();
            const blob = new Blob([uint8Array], {type: 'application/octet-binary'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            const serialNumber = informationData[i].slipNo.split('_')[2]
            a.href = url;
            a.download = `入荷報告書_${companyName}御中_${date}_0${serialNumber}.csv`;
            a.click();
            a.remove()
            }
        }
    }
    

    return (
        <div className={styles.ArrivalInformationWrapper}>
            { informationData && informationData?.length !== 0 ?
            [...Array(nComponents)].map((e,i) => <span key={i}>
                <div className={styles.ArrivalInformation}>
                    <Stack   
                        direction="row"
                        alignItems="center"
                        spacing={2}
                    >
                        <div>
                            <p className={styles.label}>伝票No.</p>
                            <p className={styles.value}>{informationData[i].slipNo}</p>
                        </div>
                        <div style={{ flexGrow: 1 }}></div>
                        <div>
                            <Button variant="contained" onClick={() => downloadCsv(i)}>入荷報告書ダウンロード</Button>
                        </div>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <div>
                            <p className={styles.label}>入荷日</p>
                            <p className={styles.value}>{dateToString(informationData[i].arrivalDate)}</p>
                        </div>
                        <div>
                            <p className={styles.label}>品番</p>
                            <p className={styles.value}>{informationData[i].productNumber}</p>
                        </div>
                        <div>
                            <p className={styles.label}>品名</p>
                            <p className={styles.value}>{informationData[i].productName}</p>
                        </div>
                        <div>
                            <p className={styles.label}>合計</p>
                            <p className={styles.value}>{informationData[i].quantity}</p>
                        </div>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Box>
                            <TableContainer component={Paper} sx={{ width: 340 }}>
                                <Table aria-label="simple table">
                                    <TableHead sx={{backgroundColor: '#E8EEF6'}}>
                                    <TableRow>
                                        <TableCell sx={{color: '#1E53A3'}}>COL</TableCell>
                                        <TableCell align="right" sx={{color: '#1E53A3'}}>SIZE</TableCell>
                                        <TableCell align="right" sx={{color: '#1E53A3'}}>数量</TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {/* {rows.map((row, index) => ())} */}
                                        <TableRow
                                        // key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                        <TableCell component="th" scope="row">
                                            {informationData[i].color}
                                        </TableCell>
                                        <TableCell align="right">{informationData[i].size}</TableCell>
                                        <TableCell align="right">{informationData[i].quantity}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box>
                            <TableContainer component={Paper} 
                            sx={{ width: 340, height: 1/1}}
                            >
                                <Table aria-label="simple table">
                                    <TableHead sx={{backgroundColor: '#E8EEF6'}}>
                                    <TableRow>
                                        <TableCell sx={{color: '#1E53A3'}}>備考</TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {informationData[i].memo}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Stack>
                </div>
            </span>)
            : <div className={styles.no_data}>表示するデータがありません</div>}
        </div>
    )
}

export default ArrivalInformation